import type { OptionItem } from "@/api/admin";

type AmountRange = {
  amountFrom?: string;
  amountTo?: string;
};

type AmountInput = string | OptionItem | undefined;

export const parseAmountRange = (input?: AmountInput): AmountRange => {
  const rawAmount = typeof input === "string" ? input : input?.name;

  if (!rawAmount) {
    return {};
  }

  if (rawAmount.includes("-")) {
    const [from, to] = rawAmount.split("-").map(v => v.trim());

    return {
      amountFrom: from || undefined,
      amountTo: to || undefined,
    };
  }

  return {
    amountFrom: rawAmount,
  };
};
